module.exports = __webpack_public_path__ + "img/business_Image_one.3d51c63a.png";